"use client"

import { DEV_BYPASS_CLERK } from "src/auth/dev-bypass"

/**
 * Tiny fixed badge that appears in the bottom-left corner whenever the
 * Clerk bypass is active. The point is to make it impossible to forget
 * that you're in bypass mode while debugging weird auth-shaped issues.
 *
 * Returns null in prod (DEV_BYPASS_CLERK is `false` and the entire branch
 * tree-shakes), and also when the bypass env var isn't set in dev — the
 * banner only renders when it's actually doing something.
 */
export function DevBypassBanner() {
  if (!DEV_BYPASS_CLERK) return null
  return (
    <div
      style={{
        position: "fixed",
        bottom: 12,
        left: 12,
        zIndex: 9999,
        padding: "6px 10px",
        borderRadius: 8,
        background: "#FEF3C7", // amber-100
        color: "#78350F", // amber-900
        border: "1px solid #F59E0B", // amber-500
        font: "500 11px ui-monospace, SFMono-Regular, Menlo, monospace",
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        boxShadow: "0 4px 10px -4px rgba(0, 0, 0, 0.2)",
        pointerEvents: "none",
        userSelect: "none",
      }}
      aria-hidden
    >
      🛠 Clerk bypass · dev only
    </div>
  )
}
